// import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router,Route,Routes } from 'react-router-dom';
import Navbar from './Components/Navbar';
// import Home from './Pages/Home';
// import Grid from './Components/Grid';
// import FramerParallax from './Components/FramerParallax';
// import ParallaxSection from './Components/ParallaxSection';
// import CustomCursor from './Components/CustomCursor';
// import Header from './Components/Header';
import { ParallaxProvider } from 'react-scroll-parallax';
// import Services from './Components/Services';
// import Check from './Components/check';
// import scrollyProgress from 'motion';

import Footer from './Components/Footer';
// import AboutPage from './Pages/Aboutpage';
// import ServicesPage from './Pages/ServicesPage';
// import ContactPage from './Pages/ContactPage';
// import TeamPage from './Pages/TeamPage';
// import ProductsPage from './Pages/ProductsPage';
// import ProductDetailsPage from './Pages/ProductDetailPage';
import Services from './Components/Services';
import Home from './Components/Home';
import Contact from './Components/Contact';
import About from './Components/About';
import Aboutpage from './Pages/Aboutpage';
import Servicespage from './Pages/Servicespage';
import Contactpage from './Pages/Contactpage';
import TermsAndConditionspage from './Pages/TermsAndConditionspage';
import Projectspage from './Pages/Projectspage';
import CustomerTestimonials from './Pages/CustomerTestimonials';
import TeamBoard from './Components/TeamBoard';
// import CircularProgress from './Components/CricularProgress';
// import motion from 'framer-motion'
// import Parallax from './Components/Parallax';
// import Demo from './Components/Demo';
function App() {
  // const { scrollYProgress } = useScroll()
  //   const scaleX = useSpring(scrollYProgress, {
  //       stiffness: 100,
  //       damping: 30,
  //       restDelta: 0.001,
  //   })
  
  return (
    <ParallaxProvider>
    <Router>
      <Navbar />
      {/* <CustomCursor/> */}
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<Aboutpage/>}/>
          <Route path="/Services" element={<Servicespage/>}/>
          <Route path="/Contact" element={<Contactpage/>}/>
          <Route path="/Terms" element={<TermsAndConditionspage/>}/>
          <Route path="/Team" element={<TeamBoard/>}/>
          <Route path="/Projects" element={<Projectspage/>}/>
          <Route path="/Reviews" element={<CustomerTestimonials/>}/>
          {/* <Route path="/Team" element={<TeamPage/>}/>
          <Route path="/Products" element={<ProductsPage/>}/>
          <Route path="/product/:param" element={<ProductDetailsPage />} />
          <Route path="/service/:param" element={<Service />} /> */}

      </Routes>
      
    <Footer/>
    </Router>
    
   
    </ParallaxProvider>
   
  );
}

export default App;
